import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {dataTypePossibleCommands} from "../../../configurationProperty/elementParseConfiguration";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-possible-commands',
    templateUrl: './possible-commands.component.html',
    styleUrls: ['./possible-commands.component.scss'],
    standalone: false
})
export class PossibleCommandsComponent implements OnInit {

    form: UntypedFormGroup;
    public dataType = dataTypePossibleCommands

    constructor(public dialogRef: MatDialogRef<PossibleCommandsComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { currentValue: any },
                private fb: UntypedFormBuilder) {
        this.form = this.fb.group({
            possibleCommands: this.fb.array([])
        });

    }

    ngOnInit(): void {
        Object.keys(this.data.currentValue);

        console.log(this.data);
    }

    sendValue(): void {
        console.log(this.form.value);
        this.dialogRef.close([1, 2, 3, 4]);
    }

    get possibleCommands(): any {
        return this.form.controls["possibleCommands"] as UntypedFormArray;
    }

    addPossibleCommands(): void {
        const lessonForm = this.fb.group({
            keyName: [null, Validators.required],
            type: [null, Validators.required]
        });
        this.possibleCommands.push(lessonForm);
    }

    deletePossibleCommands(lessonIndex: number): void {
        this.possibleCommands.removeAt(lessonIndex);
    }
}
